export const PurchasePaymentI18n = {
    title: 'Submit Payment - Override',
    checklist: {
        accountVerified: 'Account verification complete - Override',
        documentSigned: 'Subscription document signed - Override',
        paymentMethodAdded: 'Payment method added - Override',
    },
    authorization: {
        descr: `I confirm that I have read, understood, and agree to the <a data-link="tosLink"></a> and <a data-link="eftDisclosureLink"></a>, including all risk disclosures related to real-estate investments. I acknowledge that investing involves the potential loss of capital and that this service does not guarantee returns.`,
        validators: {
            required: 'Please provide the consent before proceeding - override',
        },
    },
    actions: {
        submit: 'Submit Payment - Override',
        back: 'Back - Override',
    },
    linkConfigs: [
        {
            key: 'tosLink',
            link: 'bazaCommon.links.termsOfService',
            isCMSLink: true,
            text: 'Terms of Service - Override',
        },
        {
            key: 'eftDisclosureLink',
            link: 'bazaCommon.links.eftDisclosure',
            isCMSLink: true,
            text: 'EFT Disclosure - Override',
        },
    ],
};
